import React from 'react'
import { IconMaps } from '@ow/icons'
import styled from '@emotion/styled'
import tw from 'twin.macro'
import { get } from 'lodash-es'
import nullImg from '../assets/null.png'

const StyledCover = styled.div`
  .deleteicon {
    background-color: rgba(0, 0, 0, 0.65);
    &:hover {
      background: rgba(227, 77, 89, 1);
    }
    ${tw`hidden cursor-pointer`}
  }
  &:hover {
    .deleteicon {
      ${tw`block`}
    }
  }
`

const FileNew = function ({ tbData, fileConfig, loading, onClickDelete }) {
  return (
    <div className="w-full h-full  overflow-hidden flex-1">
      <div className="h-full w-full flex flex-wrap overflow-y-auto">
        {!loading && tbData.length === 0 && (
          <div className="w-full h-full flex item-center justify-center">
            <div className="flex flex-col gap-3 items-center">
              <img
                src={nullImg}
                alt="null"
                style={{ width: '300px', height: 'auto' }}
              />
              <div>暂无文章</div>
            </div>
          </div>
        )}
        {tbData.map((data) => {
          return (
            <div className="flex flex-col gap-2 w-1/6 mb-6">
              <StyledCover
                className="relative"
                style={{ width: '92%', height: 'auto' }}
              >
                <IconMaps
                  type={fileConfig.defaultImage}
                  width="100%"
                  height="100%"
                />

                <div className="absolute right-0 top-0 deleteicon">
                  <div
                    className="flex items-center justify-center"
                    style={{
                      width: '40px',
                      height: '40px',
                    }}
                    onClick={() => {
                      onClickDelete(data.objectId)
                    }}
                  >
                    <IconMaps
                      type="delete"
                      width="20px"
                      height="20px"
                      fill="rgba(255,255,255,0.9)"
                    />
                  </div>
                </div>
              </StyledCover>
              <div className="flex flex-col gap-0.5">
                <div
                  className="cursor-pointer w-full"
                  title={data[fileConfig.title]}
                  style={{
                    overflow: 'hidden',
                    whiteSpace: 'nowrap',
                    textOverflow: 'ellipsis',
                    fontSize: '16px',
                  }}
                  onClick={() => {
                    if (data[fileConfig.link]) {
                      data[fileConfig.link].forEach((ll) => {
                        window.location.href = ll.src
                      })
                    }
                  }}
                >
                  {data[fileConfig.title]}
                </div>
                <div className="flex items-center gap-2">
                  {get(fileConfig, 'fields', []).map((field) => {
                    return (
                      <div
                        className="text-dark-300"
                        style={{ fontSize: '14px' }}
                      >
                        {field.leftTitle}
                        {data[field.slug] || field.defaultSlug}
                        {field.rightTitle}
                      </div>
                    )
                  })}
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default FileNew
